import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Explore } from 'services/explore';
import useExploreData from 'components/pages/explore/useExploreData/useExploreData';
import Spinner from '@core/components/spinner/Spinner';
import ExploreEmptyState from './exploreemptystate/ExploreEmptyState';
import ExploreContentCardNew from 'components/common/ExploreContentCardNew/ExploreContentCardNew';
import ActionButton from '@core/components/actionbutton/ActionButton';

import UseToast from 'hooks/use-toast';

import { Refresh } from 'iconsax-react';

import classes from './ExploreDataWrapperNew.module.scss';


const ExploreDataWrapperNew = ({ selectedPage, handlePageChange }) => {
	const { data, isLoading, isFetching } = useExploreData();
	const [resultCount, setResultCount] = useState();
	const { toast, ToastContainer } = UseToast();
	// accumulate results for "Load More"
	const [results, setResults] = useState([]);
	const router = useRouter();
	const [currentPage, setCurrentPage] = useState(selectedPage ? +selectedPage : 1);
	const [loadingMore, setLoadingMore] = useState(false);

	useEffect(() => {
		if (!data) return;

		const page = selectedPage ? +selectedPage : 1;

		setResultCount(data.data.count);

		if (page > 1) {
			// append new page results, dedupe by id just in case
			setResults(prev => {
				const combined = [...prev, ...data.data.results];
				const map = new Map();
				combined.forEach(item => map.set(item.id, item));
				return Array.from(map.values());
			});
			setCurrentPage(page);
		} else {
			// page 1 (or undefined): reset results
			setResults(data.data.results);
			setCurrentPage(1);
		}
	}, [data, selectedPage, setResultCount]);

	// build search params string from router.query but ignore page from URL (we'll pass page explicitly)
	const buildSearchParams = (pageToFetch) => {
		const queryParams = Object.keys(router.query)
			.filter((k) => k !== 'page')
			.reduce((result, currentKey) => {
				const newKeyValue = `&${currentKey}=${router.query[currentKey]}`;
				return result + newKeyValue;
			}, '?page_size=9');
		return `${queryParams}${pageToFetch ? `&page=${pageToFetch}` : ''}`;
	};

	const loadMore = async () => {
		if (loadingMore) return;
		const nextPage = (currentPage ? +currentPage : 1) + 1;
		setLoadingMore(true);
		try {
			const searchParams = buildSearchParams(nextPage);
			const resp = await Explore.GET(searchParams);
			if (resp && resp.data && Array.isArray(resp.data.results)) {
				setResults(prev => {
					const combined = [...prev, ...resp.data.results];
					const map = new Map();
					combined.forEach(item => map.set(item.id, item));
					return Array.from(map.values());
				});
				setResultCount(resp.data.count);
				setCurrentPage(nextPage);
			}
		} catch (e) {
			// swallow — toast could be shown if desired
		} finally {
			setLoadingMore(false);
		}
	};

	return (
		<>
			<div className="d-flex flex-column gap-4 w-100">
				{results ? (
					<>
						<div className="d-flex flex-wrap flex-column position-relative">
							{data?.data?.count === 0 ? (
								<div className={classes['empty-state-wrapper']}>
									<ExploreEmptyState />
								</div>
							) : (
								<div className={`row `}>
									{results.map((content) => (
										<div key={content.id} className={` col-xl-4 col-lg-6 col-md-12 py-4`}>
											<ExploreContentCardNew
												content={content}
												toast={toast}
											/>
										</div>
									))}
									{/* <CourseSuggestion type='long' /> */}
								</div>
							)}
						</div>
						{(currentPage ? +currentPage : 1) < Math.ceil(resultCount / 9) && (
							<div className={classes['explore-data-card-wrapper']}>
								<div className={`d-flex align-items-center justify-content-center`}>
									<ActionButton
										loading={isLoading || isFetching || loadingMore}
										kind='blank'
										onClick={loadMore}
									>
										<Refresh variant='TwoTone' size={24} /> <span className='ms-3'> Load more</span>
									</ActionButton>
								</div>
							</div>
						)}
					</>
				) : (
					<div className="d-flex align-items-center justify-content-center w-100 py-5">
						<Spinner />
					</div>
				)}
			</div>
			<ToastContainer />
		</>
	);
};

export default ExploreDataWrapperNew;
